export class Common {
	static blobToJson (blob) {
		return new Promise((resolve, reject) => {
			const reader = new FileReader()

			reader.onload = function (event) {
				const jsonString = event.target.result

				try {
					const jsonData = JSON.parse(jsonString)
					resolve(jsonData)
				} catch (error) {
					reject(error)
				}
			}

			reader.onerror = function (error) {
				reject(error)
			}

			// Read the Blob as text
			reader.readAsText(blob)
		})
	}
}
